module.exports = __webpack_public_path__ + "img/9ede6da5-8484-46c7-9330-c0edd0b87a60.89ce292c.webp";